export default class StoreCallback {
  #store;
  constructor(store) {
    this.#store = store;
  }

  info() {
  }

  success() {
    
  }

  err(err = "ошибка") {
    console.log(err)
  }

  errAuth() {
    this.#store.dispatch("Auth/logout");
  }
}